export default "__VITE_ASSET__D7V2gR76__"